export const networkCORDIS = {
  "$schema": "https://vega.github.io/schema/vega/v5.json",
  "title": { "offset": 30 },
  "signals": [
    {
      "name": "width",
      "update": "(containerSize()[0] || 400)",
      "on": [{
        "events": { "source": "window", "type": "resize" },
        "update": "containerSize()[0]"
      }]
    },
    { "name": "cx", "update": "width / 2" },
    { "name": "cy", "update": "height / 2" },
    {
      "description": "State variable for active node fix status.",
      "name": "fix",
      "value": false,
      "on": [
        {
          "events": "symbol:mouseout[!event.buttons], window:mouseup",
          "update": "false"
        },
        { "events": "symbol:mouseover", "update": "fix || true" },
        {
          "events": "[symbol:mousedown, window:mouseup] > window:mousemove!",
          "update": "xy()",
          "force": true
        }
      ]
    },
    {
      "description": "Graph node most recently interacted with.",
      "name": "node",
      "value": null,
      "on": [
        { "events": "symbol:mouseover", "update": "fix === true ? item() : node" }
      ]
    }
  ],
  "data": [
    {
      "name": "node-data",
      "values": null,
      "transform": [
        {
          "type": "window",
          "sort": { "field": "edges", "order": "descending" },
          "ops": ["rank"],
          "fields": ["edges"],
          "as": ["rank"]
        }
      ]
    },
    {
      "name": "link-data",
      "values": null
    },
    {
      "name": "legend-data",
      "source": "node-data",
      "transform": [
        {
          "type": "filter",
          "expr": "isDefined(datum.activityType)"
        }
      ]
    }
  ],
  "scales": [
    {
      "name": "shape",
      "type": "ordinal",
      "domain": { "data": "node-data", "field": "activityType" },
      "range": "symbol"
    },
    {
      "name": "edge",
      "type": "linear",
      "domain": { "data": "link-data", "field": "count" },
      "range": [0.5, 5]
    },
    {
      "name": "edge-opacity",
      "type": "linear",
      "domain": { "data": "link-data", "field": "count" },
      "range": [0.01, 0.25]
    },
    {
      "name": "node",
      "type": "linear",
      "domain": { "data": "node-data", "field": "edges" },
      "range": [30, 500]
    },
    {
      "name": "activityType",
      "type": "ordinal",
      "domain": { "data": "legend-data", "field": "activityType" },
      "range": { "scheme": "category10" }
    }
  ],
  "marks": [
    {
      "name": "nodes",
      "type": "symbol",
      "zindex": 1,
      "from": { "data": "node-data" },
      "on": [
        {
          "trigger": "fix",
          "modify": "node",
          "values": "fix === true ? {fx: node.x, fy: node.y} : {fx: fix[0], fy: fix[1]}"
        },
        {
          "trigger": "!fix",
          "modify": "node",
          "values": "{fx: null, fy: null}"
        }
      ],
      "encode": {
        "enter": {
          "fill": { "scale": "activityType", "field": "activityType" },
          "fillOpacity": { "value": 0.5 },
          "stroke": { "value": "#333" }
        },
        "update": {
          "size": { "scale": "node", "field": "edges" },
          "cursor": { "value": "pointer" }
        }
      },
      "transform": [
        {
          "type": "force",
          "iterations": 100,
          "static": true,
          "signal": "force",
          "forces": [
            { "force": "center", "x": { "signal": "cx" }, "y": { "signal": "cy" } },
            { "force": "collide", "radius": 10 },
            { "force": "nbody", "strength": -35 },
            { "force": "link", "links": "link-data", "distance": 20 }
          ]
        }
      ]
    },
    {
      "type": "path",
      "from": { "data": "link-data" },
      "interactive": false,
      "encode": {
        "update": {
          "stroke": { "value": "#333" },
          "strokeOpacity": { "scale": "edge-opacity", "field": "count" },
          "strokeWidth": { "scale": "edge", "field": "count" }
        }
      },
      "transform": [
        {
          "type": "linkpath",
          "require": { "signal": "force" },
          "shape": "line",
          "sourceX": "datum.source.x",
          "sourceY": "datum.source.y",
          "targetX": "datum.target.x",
          "targetY": "datum.target.y"
        }
      ]
    },
    {
      "type": "text",
      "zindex": 10,
      "interactive": false,
      "from": { "data": "nodes" },
      "encode": {
        "enter": {
          "dx": { "signal": "datum.edges * 4" },
          "text": { "signal": "datum.datum.rank <= 10 ? datum.datum.name : ''" }
        },
        "update": {
          "x": { "field": "x", "offset": 4 },
          "y": { "field": "y" },
          "opacity": {
            "signal": "!fix ? 1 : fix && node.datum.name === datum.datum.name ? 1 : 0.25"
          }
        }
      }
    },
    {
      "type": "text",
      "description": "text when hovering all nodes not from Toscana",
      "zindex": 20,
      "interactive": false,
      "encode": {
        "update": {
          "text": {
            "signal": "node && node.datum.rank > 10? node.datum.name : ''"
          },
          "x": { "signal": "node? node.x : 0" },
          "y": { "signal": "node? node.y : 0" }
        }
      }
    }
  ],
  "legends": [
    {
      "orient": "none",
      "labelLimit": 500,
      "gradientLength": { "signal": "clamp(height, 64, 200)" },
      "symbolType": "circle",
      "title": null,
      "titleFontSize": 14,
      "encode": {
        "legend": {
          "update": {
            "x": { "value": 0 },
            "y": { "value": 0 }
          }
        }
      },
      "fill": "activityType"
    }
  ],
  "padding": { "top": 20, "left": 15, "right": 15, "bottom": 20 },
  "autosize": "none",
  "width": 1500,
  "height": 1500
};